import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

import { EditMediaContent } from '../../@types';

interface Payload {
  id: string;
  refetchInterval?: number;
}

export const getEditVideoData = async (payload: Payload): Promise<EditMediaContent> => {
  const response = await axiosInstance.post('/api/video', { videoId: payload.id });
  return response.data;
};

export const useGetEditVideoData = (payload: Payload) => {
  return useQuery(['fetchEditVideoData', payload.id], () => getEditVideoData(payload), {
    enabled: !!payload.id,
    ...(payload?.refetchInterval && { refetchInterval: payload.refetchInterval }),
  });
};
